import { render, staticRenderFns } from "./confirmTouGao.vue?vue&type=template&id=7c122364&scoped=true&"
import script from "./confirmTouGao.vue?vue&type=script&lang=js&"
export * from "./confirmTouGao.vue?vue&type=script&lang=js&"
import style0 from "./confirmTouGao.vue?vue&type=style&index=0&id=7c122364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c122364",
  null
  
)

export default component.exports